import { motion, AnimatePresence } from 'framer-motion';
import { fadeIn } from "../styles/variants";

const WorkPopup = ({id, isToggled, setToggle}) => {
  return (
    <AnimatePresence>
      {isToggled === true && 
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.15 } }}
          transition={{ duration: 0.2, delay: 0.15 }}
          className="bg-black bg-opacity-80 w-full h-full fixed top-0 left-0 z-20 flex justify-center items-center overflow-y-auto"
        >
          <motion.div 
            initial={{ y: 50 }}
            animate={{ y: 1 }}
            exit={{ y: 30 }}
            className="flex flex-col absolute bg-gradient-to-l from-[#A3D4C8] to-[#E8BAC2] max-w-[90%] max-h-[90%] lg:w-[700px] border-2 border-white/50 rounded-xl p-6 overflow-y-auto"
          >
            <motion.div 
             variants={fadeIn('right', 0.2)} 
             initial="hidden"
             whileInView={'show'}
             viewport={{ once: false, amount: 0.3 }}
             className="hidden md:flex flex-1 max-w-[320px] lg:max-w-[482px] mx-auto pb-4"
            >
              {
                id.youtube ?
                <iframe width="430" height="265" src={id.youtube} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe> :
                <img width="430" height="265" src={id.img} alt={id.alt} />
              }
            </motion.div>
            <motion.div
              variants={fadeIn('left', 0.3)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }}
              className="mb-1"
            >
              <span className="text-gradient">
                {id.pretitle}
              </span>
              <h2 className='text-3xl text-white'>
                {id.title}
              </h2>
            </motion.div>
            <motion.div 
              variants={fadeIn('right', 0.4)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }}
              className="flex flex-col gap-2"
            >
              <div className="flex flex-wrap">
                {id.made_with.map((name, i) => <div key={i} className="text-accent m-1 px-2 bg-white rounded-lg">{name}</div>)}
              </div>
              <div className="flex flex-wrap lg:flex-nowrap text-xl">
                <span className='font-semibold'>Collaborators:</span>
                <span className="mx-2 italic">{id.collab.join(', ')}</span>
              </div>
              <p className='indent-4 leading-5 text-justify'>{id.description}</p>
              <p className='text-sm text-justify italic'>Note: {id.note}</p>
              <div className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0">
                {
                  id.deploy ?
                  (<a href={id.deploy} target="_blank" rel="noreferrer">
                    <button className='btn btn-sm'>
                      See Live
                    </button>
                   </a>) :
                  ""
                }
                {
                  id.github ?
                  (<a href={id.github} target="_blank" rel="noreferrer">
                    <button className='btn btn-sm'>
                      Source Code
                    </button>
                   </a>):
                  ""
                }
              </div>
              <button 
                className='text-gradient text-sm cursor-pointer' 
                onClick={() => setToggle(false)}
              >
                Tap to close
              </button>
            </motion.div>
          </motion.div>
        </motion.div>
      }
    </AnimatePresence>
  )
}

export default WorkPopup;